'use es6';

import PropTypes from 'prop-types';
export default PropTypes.arrayOf(PropTypes.shape({
  text: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
}));